import "./SBCustomRangeSlider.scss";

import React, { useState, useRef, useEffect } from "react";

function SBCustomRangeSlider({ min, max, setMinRange, setMaxRange }) {
  const [value1, setValue1] = useState(Number(min));
  const [value2, setValue2] = useState(Number(max));

  useEffect(() => {
    setValue1(Number(min));
    setValue2(Number(max));
  }, [min, max]);
  const handleRangeComplete = () => {
    setMinRange(Math.min(value1, value2));
    setMaxRange(Math.max(value1, value2));
  };
  const getTrackStyle = () => {
    const minPercent = ((Math.min(value1, value2) - min) / (max - min)) * 100;
    const maxPercent = ((Math.max(value1, value2) - min) / (max - min)) * 100;

    return {
      background: `linear-gradient(to right, 
        #f3f3f3 ${minPercent}%, 
        #000000 ${minPercent}%,
        #990000 ${maxPercent}%, 
        #f3f3f3 ${maxPercent}%)`,
    };
  };

  return (
    <div className="price-range-container">
      <div className="slider-value">
        <input
          type="text"
          className="min-range"
          value={Math.min(value1, value2)}
          onChange={(e) => {
            handleRangeComplete();
            const onlyDigits = Number(
              e.target.value.replace(/\D/g, "").slice(0, 11)
            );
            setValue1(onlyDigits);
          }}
        />
        <span>-</span>
        <input
          type="text"
          className="max-range"
          value={Math.max(value1, value2)}
          onChange={(e) => {
            handleRangeComplete();
            const onlyDigits = Number(
              e.target.value.replace(/\D/g, "").slice(0, 11)
            );
            setValue2(onlyDigits);
          }}
        />
      </div>

      <div className="price-range-wrapper">
        <div className="slider-track" style={getTrackStyle()}></div>

        <input
          type="range"
          min={Number(min)}
          max={Number(max)}
          step="100"
          value={value1}
          onChange={(e) => setValue1(Number(e.target.value))}
          onMouseUp={handleRangeComplete}
          onTouchEnd={handleRangeComplete}
          className="thumb thumb-left"
        />

        <input
          type="range"
          min={Number(min)}
          max={Number(max)}
          step="100"
          value={value2}
          onChange={(e) => setValue2(Number(e.target.value))}
          onMouseUp={handleRangeComplete}
          onTouchEnd={handleRangeComplete}
          className="thumb thumb-right"
        />
      </div>
    </div>
  );
}

export default SBCustomRangeSlider;
